import { Layout } from "antd";
import React from "react";
import "./BaseFooter.less";
import Powered_by from "../../Assets/Images/Powered_by.svg";
import * as moment from "moment";

const { Footer } = Layout;

export const FooterPage = () => {
  return (
    <Footer className="footerPage text-center d-flex align-items-center justify-content-between">
      <span style={{ color: "var(--secondary)" }}>
        Copyright © {moment().format("YYYY")} SanAttest™. All rights reserved.
      </span>
      <div className="d-flex align-items-center pr-5 flex-wrap justify-content-center">
        <a
          alt=""
          className="text-secondary"
          target="_blank"
          href="https://sanattest.com/#contact-us"
        >
          Contact
        </a>
        <span className="px-2">-</span>
        <a
          alt=""
          className="text-secondary"
          target="_blank"
          href="https://sanattest.com/terms-conditions/"
        >
          Terms of use
        </a>
        <span className="px-2">-</span>
        <a
          alt=""
          className="text-secondary"
          target="_blank"
          href="https://sanattest.com/privacy-policy/"
        >
          Privacy Policy
        </a>
        <a
          alt=""
          className="text-secondary powered_by"
          target="_blank"
          href="https://intellimedianetworks.com/"
        >
          <img src={Powered_by} alt="" className="pr-md-5 pl-md-3 " />
        </a>
      </div>
    </Footer>
  );
};
